// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2EVrT","content":"styles_content__3ejwF","selectAll":"styles_selectAll__1uf9J"};